import { DateTime } from 'luxon'
import React from 'react'


export enum formats {
  ISO = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
  SIMPLE = 'yyyy-MM-dd',
}

export default class DateUtil {
  static getSweDateTimeNow() {
    return DateTime.local().setZone('Europe/Stockholm')
  }

  static getSweDateNow() {
    const today = this.getSweDateTimeNow()
    return today.startOf('day')
  }

  static getSweDateTimeFromString(dateString: string, format: string) {
    return DateTime.fromFormat(dateString, format, { zone: 'Europe/Stockholm' })
  }

  static getSweDateTimeFromISO(dateString: string, format?: string) {
    return DateTime.fromISO(dateString, { zone: 'Europe/Stockholm' })
  }

  static getSweDateTimeElementFromISOWithFormat(dateString: string) {
    const date = DateTime.fromISO(dateString, {
      zone: 'Europe/Stockholm',
    }).toFormat("yyyy-MM-dd'#'HH:mm")
    const datePart = React.createElement(
      'div',
      {
        key: 'A',
        className: 'l-min-width--6',
      },
      [date.split('#')[0]],
    )
    const timePart = React.createElement('div', { key: 'B' }, [
      date.split('#')[1],
    ])
    const container = React.createElement(
      'div',
      { key: 'C', className: 'l-columns' },
      [datePart, timePart],
    )
    return container
  }

  static getSweDateTimeFromMillis(dateMillis: number) {
    return DateTime.fromMillis(dateMillis, { zone: 'Europe/Stockholm' })
  }

  static diffSweDateTimesFromString(
    dateStringA: string,
    dateStringB: string,
  ): number {
    const dateA = DateTime.fromISO(dateStringA, {
      zone: 'Europe/Stockholm',
    })
    const dateB = DateTime.fromISO(dateStringB, {
      zone: 'Europe/Stockholm',
    })
    return dateA.diff(dateB).valueOf()
  }

  static diffSweDateTimesFromISO(isoDateA: string, isoDateB: string): number {
    const dateA = DateTime.fromISO(isoDateA, { zone: 'Europe/Stockholm' })
    const dateB = DateTime.fromISO(isoDateB, { zone: 'Europe/Stockholm' })
    return dateA.diff(dateB).valueOf()
  }
}
